/*
 * 実行
 *
 *-------------------------------------*/
var	securitiesCode	= 8111,		// 証券コード
    creationDate = '20241111',  // 作成日
	qir_directory	= ( location.hash != "#demo" && document.domain.indexOf('customer2') ===-1 && document.domain.indexOf('aspdev') ===-1  ) ? "QIR" : "QIR_demo",
	init_directory	= ( location.hash != "#demo" && document.domain.indexOf('customer2') ===-1 && document.domain.indexOf('aspdev') ===-1  ) ? "public" : "demo",
	protocol		= ( location.protocol == "https:" ) ? "https" : "http";

document.write("<script type='text/javascript' src='" + protocol + "://ssl4.eir-parts.net/Custom/public/material/qirex/common/jquery.js'></script>");
document.write("<script type='text/javascript' src='" + protocol + "://ssl4.eir-parts.net/Custom/public/material/chartgen/common/highcharts.js'></script>");
document.write("<script type='text/javascript' src='" + protocol + "://ssl4.eir-parts.net/Custom/public/material/chartgen/common/exporting.js'></script>");
// 本番用
document.write("<script type='text/javascript' src='" + protocol + "://ssl4.eir-parts.net/Custom/public/material/chartgen/common/jquery.chartgenerator.js'></script>");
// デモ用
//document.write("<script type='text/javascript' src='jquery.chartgenerator/jquery.chartgenerator.js'></script>");

if( (document.location.protocol == 'https:' || document.location.protocol == 'http:') && !/aspdev/.test(window.location.host)){
	document.write('<link rel="stylesheet" type="text/css" href="' + protocol + '://ssl4.eir-parts.net/Custom/' + init_directory + '/qir/' + securitiesCode + '/ex/' + creationDate + '/chartgenerator.css">');
	document.write('<script type="text/javascript" src="' + protocol + '://ssl4.eir-parts.net/Custom/' + init_directory + '/qir/' + securitiesCode + '/ex/' + creationDate + '/init_chartgenerator_e.js"></script>');
}
else{
	document.write('<link rel="stylesheet" type="text/css" href="/ex/'+ creationDate +'/chartgenerator.css">');
	document.write('<script type="text/javascript" src="/ex/'+ creationDate +'/init_chartgenerator_e.js"></script>');
}

document.write("<script type='text/javascript' src='" + protocol + "://ssl4.eir-parts.net/" + qir_directory + "/" + securitiesCode + "/graph_" + securitiesCode + "_utf-8_yosou.js'></script>");